import React, { useState } from 'react';
import { generateDriverReport, REPORTABLE_STATUSES } from './utils/reportGenerator';

const PrintDailySummary = ({ packages, userId }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  // Must mirror generateDriverReport's own filter exactly. When it did not, the
  // button enabled on packages the generator then rejected, and the only signal
  // was "No packages found for this driver" after the click.
  const driverPackages = packages.filter(
    (pkg) =>
      REPORTABLE_STATUSES.includes((pkg.status || '').toLowerCase()) &&
      pkg.assignedTo === userId &&
      !pkg.driverReportId
  );

  const deliveredPackages = driverPackages.filter(
    pkg => (pkg.status || '').toLowerCase() === "delivered"
  );
  const otherPackages = driverPackages.length - deliveredPackages.length;

  const handleDownloadSummary = async () => {
    if (!window.confirm(
      `Generate the driver summary for ${driverPackages.length} package${driverPackages.length === 1 ? '' : 's'}?\n\n`
      + `• ${deliveredPackages.length} delivered will be marked paid and have a payment recorded.\n`
      + `• ${otherPackages} canceled will be listed on the report only — no payment.\n\n`
      + `Packages already included in a previous report are excluded.`
    )) {
      return;
    }

    setIsDownloading(true);

    try {
      const { reportId, downloadURL } = await generateDriverReport(
        packages, 
        userId,
        { shouldUpdatePackageStatus: true } // Update package status from PrintDailySummary
      );
      
      alert(`Report generated and saved successfully!\n\nReport ID: ${reportId}\nURL: ${downloadURL}`);

    } catch (error) {
      console.error("Error generating/uploading report:", error);
      alert(`Failed to generate the driver summary.\n\n${error.message || 'Please try again.'}`);
    } finally {
      setIsDownloading(false);
    }
  };

  const hasDriverPackages = driverPackages.length > 0;

  return (
    <div className="flex justify-center mt-8">
      <button
        onClick={handleDownloadSummary}
        disabled={!hasDriverPackages || isDownloading}
        className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 transition-colors"
      >
        {isDownloading ? 'Generating & Uploading...' : 'Print Driver Summary'}
      </button>
    </div>
  );
};

export default PrintDailySummary;